import {combineReducers} from "redux";
import {linkRef, event, documentList, candidateLocation, uploadedFiles} from "./reducers"
export default combineReducers({linkRef, event, documentList, candidateLocation, uploadedFiles});
